// extracted by mini-css-extract-plugin
export var bxTextTruncateEnd = "ImageGallery-module--bx--text-truncate--end--KjUe0";
export var bxTextTruncateFront = "ImageGallery-module--bx--text-truncate--front--2HS+3";
export var addNoScroll = "ImageGallery-module--add-no-scroll--JaPaN";
export var inDialogGalleryContainer = "ImageGallery-module--in-dialog-gallery-container--d69+5";
export var galleryGrid = "ImageGallery-module--gallery-grid--41Puq";
export var galleryRow = "ImageGallery-module--gallery-row--CDdFC";
export var navButtonsContainer = "ImageGallery-module--nav-buttons-container--YOf2G";
export var navButtons = "ImageGallery-module--nav-buttons--6F7Qn";
export var leftNav = "ImageGallery-module--left-nav--0XQSg";
export var rightNav = "ImageGallery-module--right-nav--qSHLN";
export var firstRightNav = "ImageGallery-module--first-right-nav--lCTgp";
export var icon = "ImageGallery-module--icon--PVAiK";
export var closeButton = "ImageGallery-module--close-button--1266B";
export var galleryContainer = "ImageGallery-module--gallery-container--yRZ7o";
export var column = "ImageGallery-module--column--6vwjb";
export var figure = "ImageGallery-module--figure--GJN+d";
export var imageButtonWrapper = "ImageGallery-module--image-button-wrapper--0n+0+";
export var imageTitle = "ImageGallery-module--image-title--5-NvE";
export var imageInDialog = "ImageGallery-module--image-in-dialog--9nCHk";